import React from "react";
import { Col, Row } from "react-bootstrap";
import LoadManuals from "../../../components/load-manuals/LoadManuals";

const Manuals = () => {

  return (
    <Row className="h-100">
      <Col col={12} className="col-12 mb-4">
        <LoadManuals/>
      </Col>
    </Row>
  );
};

export default Manuals;
